import React from 'react';

// UI
import Loader from '@sift/skipper/components/Loader';
import ErrorView from './ErrorView';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

export default withStyles(theme => {
  return {
    root: {
      position: 'relative',
      minHeight: '100px',
    },
    overlay: {},
    overlayTransparent: {},
  };
})(props => {
  return (
    <Loader
      isLoadingView={<CircularProgress aria-label="loader" />}
      isErrorView={<ErrorView />}
      {...props}
    />
  );
});
